import { t } from 'i18next';
import { Game } from '../../../interface/response/CashRegisterDataResponse';
import MoneyRow from './MoneyRow';
interface AplicationProps {
  games: Game[];
}
const Aplications: React.FC<AplicationProps> = ({ games }) => {
  return (
    <div className="aplications_container container">
      {games.map((game: Game, index: number) => (
        <div className="game item" key={index}>
          <span className="title">{game.GameName}</span>
          <div className="game_container values">
            <MoneyRow label={t('cashRegister.table.details.payIn')} amount={game?.PayIn} className="game_row" />
            <MoneyRow label={t('cashRegister.table.details.payOut')} amount={game?.PayOutAfterTax} className="game_row" />
            <MoneyRow label={t('cashRegister.table.details.balance')} amount={game?.Balance} className="game_row" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Aplications;
